<template>
    <div class="item w-full">
        <div class="m-4 text-center" v-if="item">
            <div class="mb-8">
                <img class="w-56 imgfit h-56 rounded-full mx-auto black" :src="item.img">
            </div>
            <div class="mb-8">
                <h4 class="text-xl font-bold" :class="(dark) ? 'text-white' : 'text-black'">{{item.name}}</h4>
            </div>
            <p :class="(dark) ? 'text-widgetheaderLight' : 'text-par'">{{item.bio}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Bio',
    props: {
        item: {
            type: Object,
        },
        dark: {
            type: Boolean
        }
    },
}
</script>